import { roleLabel } from 'common/share-dialog';
import { getRoleDisplay } from 'helpers/utils';
import { ShareRole } from 'networking/controllers/shares-controller';

export const parseVaultsCollaborators = (
  vaultsCollaborators: VaultType[],
): VaultCollaboratorsType[] =>
  vaultsCollaborators.map((vault) => ({
    id: vault.id,
    title: vault.title,
    coverUrl: vault.coverUrl,
    subscriptionStatus: vault.subscriptionStatus as SubscriptionStatus,
    subscriptionType: vault.subscriptionType,
    owner: vault.owner,
    collaborators: vault.contributors
      .map(
        (contributor): VaultCollaboratorType => ({
          id: contributor.id ?? -1,
          invitationId: contributor.invitationId,
          name: contributor.name,
          email: contributor.email,
          invitationStatus: contributor.invitationStatus,
          type: 'contributor' as CollaboratorType,
          role: contributor.accessRole,
          scope: { type: 'vault' },
          itemId: contributor.invitationId!,
          contributions: contributor.contributions,
        }),
      )
      .concat(
        vault.guests.map(
          (guest): VaultCollaboratorType => ({
            id: guest.id,
            name: guest.name,
            email: guest.email,
            invitationStatus: guest.invitationStatus,
            type: 'guest' as CollaboratorType,
            role: guest.accessLevel,
            scope: guest.scope,
            invitationId: undefined,
            itemId: guest.id,
            contributions: guest.contributions,
          }),
        ),
      ),
    contributorTotal: vault.contributorTotal ?? 0,
    guestTotal: vault.guestTotal ?? 0,
  }));

// "Editor", or "Editor · Album: Trip to Iceland" when their access covers one
// album or memory, in the share dialog's words. Without a role (an older
// response), the collaborator type as before.
export const collaboratorRoleLabel = ({
  type,
  role,
  scope,
}: Pick<VaultCollaboratorType, 'type' | 'role' | 'scope'>): string => {
  if (!role) return getRoleDisplay(type);

  const on = scope?.type ?? 'vault';
  const label = roleLabel(role as ShareRole, on);
  if (on === 'vault') return label;

  return `${label} · ${on === 'album' ? 'Album' : 'Memory'}: ${
    scope?.name || 'untitled'
  }`;
};
